import { RequestStatus } from "./types";
import { UIChip } from "../_app/components";
import { JSX } from "react";

export const RequestStatusLabel: { [key in RequestStatus]: JSX.Element | string } = {
  [RequestStatus.PENDING_CREATE]: (
    <UIChip
      label="Pending creation"
      size="small"
      sx={{ backgroundColor: "#FEF3C7", color: "#92400E", border: "1px solid #F59E0B" }}
    />
  ),
  [RequestStatus.PENDING_UPDATE]: (
    <UIChip
      label="Pending update"
      size="small"
      sx={{ backgroundColor: "#FEF3C7", color: "#92400E", border: "1px solid #F59E0B" }}
    />
  ),
  [RequestStatus.PENDING_DELETE]: (
    <UIChip
      label="Pending delete"
      size="small"
      sx={{ backgroundColor: "#FEF3C7", color: "#92400E", border: "1px solid #F59E0B" }}
    />
  ),
  [RequestStatus.ACTIVE]: "Active",
  [RequestStatus.FAILED]: (
    <UIChip label="Failed" size="small" sx={{ backgroundColor: "#FEE2E2", color: "#991B1B", border: "1px solid #DC2626" }} />
  ),
};
